import { environment } from "../../environments/environment";
import { CwtLanguageConfig } from '@shared/modules/language';

export const KatchaLanguageConfig: CwtLanguageConfig = {
    appName: 'katcha',
    translationFilePath: environment.translateFilePath,
    default: 'fr',
    locales: ['fr', 'en', 'de', 'it', 'nl', 'es'],
    storageKey: 'cwt-katcha-language'
}